import { type BlocksContent } from '@strapi/blocks-react-renderer';

interface Fallbacks {
  [key: string]: BlocksContent;
}

const fallbacks: Fallbacks = {
  ['activate-membership-annual']: [
    {
      type: 'paragraph',
      children: [
        {
          text: 'By clicking “CONFIRM PURCHASE,” you agree to be charged $259.96 for your first 4 boxes and each year thereafter until you cancel. Taxes, shipping and handling fees, and, for non-US customers, foreign exchange or transaction fees may also apply. Cancel anytime before your next bill date online or by contacting FabFitFun Support ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/',
          type: 'link',
          children: [
            {
              text: 'here',
              type: 'text',
            },
          ],
        },
        {
          text: '. For more details, ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/en/articles/47-how-do-i-cancel-my-membership',
          type: 'link',
          children: [
            {
              text: 'click here',
              type: 'text',
            },
          ],
        },
        {
          text: '.',
          type: 'text',
        },
      ],
    },
  ],
  ['activate-membership-seasonal']: [
    {
      type: 'paragraph',
      children: [
        {
          text: 'By clicking “CONFIRM PURCHASE,” you agree to be charged $79.99 each season. Subscriptions are automatically charged until you cancel. Taxes, shipping and handling fees, and, for non-US customers, foreign exchange or transaction fees may also apply. Cancel anytime before your next bill date online or by contacting FabFitFun Support ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/',
          type: 'link',
          children: [
            {
              text: 'here',
              type: 'text',
            },
          ],
        },
        {
          text: '. For more details, ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/en/articles/47-how-do-i-cancel-my-membership',
          type: 'link',
          children: [
            {
              text: 'click here',
              type: 'text',
            },
          ],
        },
        {
          text: '.',
          type: 'text',
        },
      ],
    },
  ],
  ['activate-membership-seasonal-price-increase']: [
    {
      type: 'paragraph',
      children: [
        {
          text: 'By clicking below, you agree to be charged $59.99 USD* for your first season and $69.99/season thereafter. Subscriptions are automatically charged until you cancel. Taxes, shipping and handling fees, and, for non-US customers, foreign exchange or transaction fees may also apply. Cancel anytime before your next bill date online or by contacting FabFitFun Support ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/',
          type: 'link',
          children: [
            {
              text: 'here',
              type: 'text',
            },
          ],
        },
        {
          text: '. For more details, ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/en/articles/33-what-s-your-cancellation-policy',
          type: 'link',
          children: [
            {
              text: 'click here',
              type: 'text',
            },
          ],
        },
        {
          text: '.',
          type: 'text',
        },
      ],
    },
  ],
  gtb: [
    {
      type: 'paragraph',
      children: [
        {
          text: 'FabFitFun is an ongoing subscription service that is automatically charged each season ($69.99 USD) or annually ($219.99 USD for 4 seasons), depending on the option chosen, to the payment method provided until you cancel. Taxes, shipping and handling fees, and, for non-US customers, foreign exchange or transaction fees may also apply. You may cancel your subscription at any time before your next bill date online or by contacting FabFitFun Support ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/',
          type: 'link',
          children: [
            {
              text: 'here',
              type: 'text',
            },
          ],
        },
        {
          text: '. For more details, ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/en/articles/47-how-do-i-cancel-my-membership',
          type: 'link',
          children: [
            {
              text: 'click here',
              type: 'text',
            },
          ],
        },
        {
          text: '.',
          type: 'text',
        },
        {
          url: 'https://legal.fabfitfun.com/#box-membership-terms',
          type: 'link',
          children: [
            {
              text: '',
              type: 'text',
            },
          ],
        },
        {
          text: '',
          type: 'text',
        },
      ],
    },
  ],
  ['gtb-price-increase']: [
    {
      type: 'paragraph',
      children: [
        {
          text: 'FabFitFun is an ongoing subscription service that is automatically charged each season ($59.99 USD) or annually ($219.99 USD for 4 seasons), depending on the option chosen, to the payment method provided until you cancel. After 4/11/2024 memberships will be billed at $69.99 USD/season or $219.99 USD/year, depending on the option chosen. Taxes, shipping and handling fees, and, for non-US customers, foreign exchange or transaction fees may also apply. You may cancel your subscription at any time before your next bill date online or by contacting FabFitFun Support ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/',
          type: 'link',
          children: [
            {
              text: 'here',
              type: 'text',
            },
          ],
        },
        {
          text: '. For more details, ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/en/articles/47-how-do-i-cancel-my-membership',
          type: 'link',
          children: [
            {
              text: 'click here',
              type: 'text',
            },
          ],
        },
        {
          text: '.',
          type: 'text',
        },
      ],
    },
  ],
  ['gtb-thank-you']: [
    {
      type: 'paragraph',
      children: [
        {
          text: 'As a reminder, FabFitFun is an ongoing subscription service that is automatically billed each season ($79.99 USD) or annually ($259.96 for 4 seasons), depending on the option chosen, to the payment method provided until you cancel. Taxes, shipping and handling fees, and, for non-US customers, foreign exchange or transaction fees, may also apply. You may cancel your subscription at any time before your next bill date online or by contacting FabFitFun Support ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/',
          type: 'link',
          children: [
            {
              text: 'here',
              type: 'text',
            },
          ],
        },
        {
          text: '. For more details, ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/en/articles/47-how-do-i-cancel-my-membership',
          type: 'link',
          children: [
            {
              text: 'click here',
              type: 'text',
            },
          ],
        },
        {
          text: '.',
          type: 'text',
        },
      ],
    },
  ],
  ['intro-checkout']: [
    {
      type: 'heading',
      level: 6,
      children: [
        {
          text: 'About Your Membership',
          type: 'text',
        },
      ],
    },
    {
      type: 'paragraph',
      children: [
        {
          text: 'Your Seasonal Membership starts with your initial product purchase (but does not include the current Seasonal Box). Your membership continues and you will be automatically charged $69.99 each season thereafter. Choose the Seasonal Box or credit to shop our sales. Cancel any time before your next ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/en/articles/4-billing-shipping-schedule',
          type: 'link',
          children: [
            {
              text: 'bill date',
              type: 'text',
            },
          ],
        },
        {
          text: ' on the "My Account" page or by calling 1.855.313.6267.',
          type: 'text',
        },
      ],
    },
  ],
  ['intro-checkout-disclaimer-price-increase']: [
    {
      type: 'heading',
      level: 6,
      children: [
        {
          text: 'Seasonal Membership',
          type: 'text',
        },
      ],
    },
    {
      type: 'paragraph',
      children: [
        {
          text: 'Get access to the world’s best products up to 70% off! Each season choose our curated box or shop our member sales. Auto-billed seasonally for $59.99. Cancel anytime.',
          type: 'text',
        },
      ],
    },
    {
      type: 'paragraph',
      children: [
        {
          text: '*Free shipping only applicable in the contiguous US.',
          type: 'text',
        },
      ],
    },
    {
      type: 'paragraph',
      children: [
        {
          text: 'Your payment method will be charged at the introductory offer price listed above for the first season and will be automatically charged $69.99 each season thereafter, until you cancel.  Taxes, shipping and handling fees, and, for non-US customers, foreign exchange or transaction fees may also apply. You may cancel your subscription at any time before your next bill date online or by contacting FabFitFun Support ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/',
          type: 'link',
          children: [
            {
              text: 'here',
              type: 'text',
            },
          ],
        },
        {
          text: '. For more details click ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/en/articles/33-what-s-your-cancellation-policy',
          type: 'link',
          children: [
            {
              text: 'here',
              type: 'text',
            },
          ],
        },
        {
          text: '.',
          type: 'text',
        },
      ],
    },
  ],
  ['reactivate-my-membership']: [
    {
      type: 'paragraph',
      children: [
        {
          text: 'FabFitFun is an ongoing subscription service that is automatically billed each season ($79.99 USD) or annually ($259.96 USD for 4 seasons), depending on the option chosen, to the payment method provided until you cancel. Taxes, shipping and handling fees, and, for non-US customers, foreign exchange or transaction fees, may also apply. You may cancel your subscription at any time before your next bill date online or by contacting FabFitFun Support ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/',
          type: 'link',
          children: [
            {
              text: 'here',
              type: 'text',
            },
          ],
        },
        {
          text: '. For more details, ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/en/articles/47-how-do-i-cancel-my-membership',
          type: 'link',
          children: [
            {
              text: 'click here',
              type: 'text',
            },
          ],
        },
        {
          text: '.',
          type: 'text',
        },
      ],
    },
    {
      type: 'paragraph',
      children: [
        {
          text: 'By Clicking "Reactivate Me", you authorize us to reactivate your subscription and charge your payment method provided. You are also agreeing to abide by our ',
          type: 'text',
        },
        {
          url: 'https://legal.fabfitfun.com/#terms-of-use',
          type: 'link',
          children: [
            {
              text: 'Terms of Use and Sale',
              type: 'text',
            },
          ],
        },
        {
          text: ' and FabFitFun ',
          type: 'text',
        },
        {
          url: 'https://legal.fabfitfun.com/#box-membership-terms',
          type: 'link',
          children: [
            {
              text: 'Membership Terms',
              type: 'text',
            },
          ],
        },
        {
          text: '.',
          type: 'text',
        },
      ],
    },
  ],
  ['reactivate-today-1']: [
    {
      type: 'paragraph',
      children: [
        {
          text: 'By clicking “Reactivate Me”, you authorize us to reactivate your subscription. You will be enrolled in the same plan in which you were previously subscribed and charged on the next applicable billing date. Click ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/en/articles/4-billing-shipping-schedule',
          type: 'link',
          children: [
            {
              text: 'here',
              type: 'text',
            },
          ],
        },
        {
          text: ' for more information on billing dates.',
          type: 'text',
        },
      ],
    },
  ],
  ['reactivate-today-2']: [
    {
      type: 'paragraph',
      children: [
        {
          text: 'You will be automatically charged each season ($69.99 USD) or annually ($219.99 USD for 4 seasons), depending on your original option chosen to the payment method provided until you cancel. Taxes, shipping and handling fees, and, for non-US customers, foreign exchange or transaction fees may also apply. Cancel any time before your next bill date online or by contacting FabFitFun Support ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/',
          type: 'link',
          children: [
            {
              text: 'here',
              type: 'text',
            },
          ],
        },
        {
          text: '. For more details, ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/en/articles/47-how-do-i-cancel-my-membership',
          type: 'link',
          children: [
            {
              text: 'click here',
              type: 'text',
            },
          ],
        },
        {
          text: '. You are also agreeing to abide by our ',
          type: 'text',
        },
        {
          url: 'https://legal.fabfitfun.com/#terms-of-use',
          type: 'link',
          children: [
            {
              text: 'Terms of Use and Sale',
              type: 'text',
            },
          ],
        },
        {
          text: ' and ',
          type: 'text',
        },
        {
          url: 'https://legal.fabfitfun.com/#box-membership-terms',
          type: 'link',
          children: [
            {
              text: 'FabFitFun Membership Terms',
              type: 'text',
            },
          ],
        },
        {
          text: '.',
          type: 'text',
        },
      ],
    },
  ],
  ['refill-checkout']: [
    {
      type: 'heading',
      level: 6,
      children: [
        {
          text: 'About Your Product Subscriptions',
          type: 'text',
        },
      ],
    },
    {
      type: 'paragraph',
      children: [
        {
          text: 'Product subscriptions are ongoing and will be automatically charged and shipped with your Seasonal Box unless you cancel before your next billing date. Cancel on the “My Subscriptions” page or by calling 1.855.313.6267.',
          type: 'text',
        },
      ],
    },
  ],
  ['swap-for-credit-annual']: [
    {
      type: 'paragraph',
      children: [
        {
          text: '*Swap for Credit for the Summer 2025 box is now closed. Swap for Credit for the Fall 2025 season can be requested until Monday, August 4, 2025, 11:59 PM PT. Swaps requested before July 31 will be processed within 1-2 business days once your designated ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/en/articles/34-when-do-add-ons-customization-open',
          type: 'link',
          children: [
            {
              text: 'Add-Ons',
              type: 'text',
            },
          ],
        },
        {
          text: " window opens on July 31. Swaps requested after July 31 will be processed within 1-2 business days of your request. Your $54.99 USD credit will appear in your account once your swap is processed. Your credit can be used towards future FabFitFun purchases, excluding gift cards, and may be subject to other limitations, at FabFitFun's sole discretion. Credit can be used towards reFills and Additional Choice items in any future season you receive a box. Visit our ",
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/en',
          type: 'link',
          children: [
            {
              text: 'FAQ',
              type: 'text',
            },
          ],
        },
        {
          text: ' for more info.',
          type: 'text',
        },
      ],
    },
  ],
  ['swap-for-credit-seasonal']: [
    {
      type: 'paragraph',
      children: [
        {
          text: '*Swap for Credit for the Summer 2025 box is now closed. Swap for Credit for the Fall 2025 season can be requested until Monday, August 18, 2025, 11:59 PM PT. Swaps requested before August 14 will be processed within 1-2 business days once your designated ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/en/articles/34-when-do-add-ons-customization-open',
          type: 'link',
          children: [
            {
              text: 'Add-Ons',
              type: 'text',
            },
          ],
        },
        {
          text: " window opens on August 14. Swaps requested after August 14 will be processed within 1-2 business days of your request. You will be charged $69.99 USD (plus shipping and taxes, if applicable) and issued a credit for the same amount when your swap is processed. Your credit can be used towards future FabFitFun purchases, excluding gift cards, and may be subject to other limitations, at FabFitFun's sole discretion. Credit can be used towards reFills and Additional Choice items in any future season you receive a box. Visit our ",
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/en',
          type: 'link',
          children: [
            {
              text: 'FAQ',
              type: 'text',
            },
          ],
        },
        {
          text: ' for more info.',
          type: 'text',
        },
      ],
    },
  ],
  ['upgrade-to-annual-membership']: [
    {
      type: 'paragraph',
      children: [
        {
          text: 'By clicking “YES, UPGRADE ME”, you authorize us to immediately charge $179.85 USD to the payment method on file for a pro-rated annual subscription (three seasons). Your subscription will continue until canceled and, because our prices are increasing on July 24th, you will be charged $259.99 USD on your next billing date. Taxes, shipping and handling fees, and, for non-US customers, foreign exchange or transaction fees may apply. You may cancel your subscription at any time before your next bill date online or by contacting FabFitFun Support ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/en',
          type: 'link',
          children: [{ text: 'here', type: 'text' }],
        },
        { text: '. For more details, ', type: 'text' },
        {
          url: 'https://support.fabfitfun.com/en/articles/47-how-do-i-cancel-my-membership',
          type: 'link',
          children: [{ text: 'click here', type: 'text' }],
        },
        { text: '. ', type: 'text' },
      ],
    },
    {
      type: 'paragraph',
      children: [{ text: ' ', type: 'text' }],
    },
    {
      type: 'paragraph',
      children: [
        {
          text: '*vs. Comp value & based on annual members who shopped at least one additional sale in 2022.',
          type: 'text',
        },
      ],
    },
  ],
  ['upgrade-today']: [
    {
      type: 'paragraph',
      children: [
        {
          text: 'By clicking “YES, UPGRADE ME,” you authorize FabFitFun to immediately charge $259.96 USD, minus any applicable discount, to the payment method provided for an additional 4 boxes to your account. Your subscription will continue until canceled and you will be charged $259.96 USD on your next billing date. Taxes, shipping and handling fees, and, for non-US customers, foreign exchange or transaction fees may apply. You may cancel your subscription at any time before your next bill date online or by contacting FabFitFun Support ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/',
          type: 'link',
          children: [{ text: 'here', type: 'text' }],
        },
        {
          text: '. For more details, ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/en/articles/47-how-do-i-cancel-my-membership',
          type: 'link',
          children: [{ text: 'click here', type: 'text' }],
        },
        {
          text: '.',
          type: 'text',
        },
      ],
    },
  ],
  ['upgrade-to-annual-membership-control']: [
    {
      type: 'paragraph',
      children: [
        {
          text: 'By clicking “YES, UPGRADE ME,” you authorize FabFitFun to immediately charge $259.96 USD, minus any applicable discount, to the payment method provided for an additional 4 boxes to your account. Your subscription will continue until canceled and you will be charged $259.96 USD on your next billing date. Taxes, shipping and handling fees, and, for non-US customers, foreign exchange or transaction fees may apply. You may cancel your subscription at any time before your next bill date online or by contacting FabFitFun Support ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/',
          type: 'link',
          children: [{ text: 'here', type: 'text' }],
        },
        {
          text: '. For more details, ',
          type: 'text',
        },
        {
          url: 'https://support.fabfitfun.com/en/articles/47-how-do-i-cancel-my-membership',
          type: 'link',
          children: [{ text: 'click here', type: 'text' }],
        },
        {
          text: '.',
          type: 'text',
        },
      ],
    },
  ],
};

export default fallbacks;
